import {
  Base,
  Component,
  Inject,
  InjectReactive,
  Mixins,
  Prop,
  Watch
} from '@/vue-property-decorator'
import { _CircleStarBase as CircleStarBase } from './cssVar/circleStarBase'
import { _CircleStarDefault as CircleStarDefault } from './cssVar/circleStarDefault'
import { _CircleStarSmall as CircleStarSmall } from './cssVar/circleStarSmall'
import { GameCardCommonProps } from '../../../common.type'
import { GetCssVarManager } from '../../../../components/baseCssVarProvide'
import BaseCssVarInject from '../../../../components/baseCssVarInject'
import style from './style.module.scss'
export { CircleStarBase, CircleStarDefault, CircleStarSmall }
export type CircleStarCssVarManager = GetCssVarManager<CircleStarBase>
export type Props = {
  /** 动画效果是否可用 */
  isUsableAnimation?: boolean
  rootPath?: string
}
/** 圆形+星 */
@Component<CircleStar31>({
  name: 'CircleStar31'
})
export default class CircleStar31 extends Mixins<
  Base<Props>,
  BaseCssVarInject<CircleStarBase>
>(Base, BaseCssVarInject) {
  public static getCircleStarDefault = () => new CircleStarDefault()
  public static getCircleStarSmall = () => new CircleStarSmall()
  @InjectReactive()
  private isFavorited!: boolean
  /** 接收根级传入的Props */
  @Inject() cardProps!: Required<GameCardCommonProps>

  @Prop({ default: true })
  private isUsableAnimation!: Props['isUsableAnimation']

  @Prop({ default: '/lobby_asset/{layout}-{bg}-{skin}/common/home/' })
  private rootPath!: Props['rootPath']

  /** 是否展示动画 */
  private isShowAnimation = false

  @Watch('isFavorited')
  protected changeIsShowAnimation(it: boolean, old: boolean) {
    // 只有当选中状态,从false变为true时,才显示动画,其它时间都不展示动画的.
    if (it === true && old === false) {
      this.isShowAnimation = true
    } else {
      this.isShowAnimation = false
    }
  }

  /** 最终呈现的已收藏状态的图标 */
  private get collectedIcon() {
    const { isAtSwiper, atSwiperDomId } = this.cardProps
    return (
      <my-img
        options={{ lazy: !isAtSwiper, immediate: isAtSwiper, type: 'div' }}
        syncGroupsSrc={isAtSwiper}
        syncGroupsWrapId={atSwiperDomId}
        class={style['img-div']}
        src={this.rootPath + 'btn_sc_on.png'}
      />
    )
  }

  render() {
    const { isAtSwiper, atSwiperDomId } = this.cardProps
    return (
      <div
        class={{
          [style['circle-star']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType)
        }}
      >
        {this.isFavorited ? (
          this.collectedIcon
        ) : (
          <my-img
            options={{ lazy: !isAtSwiper, immediate: isAtSwiper, type: 'div' }}
            syncGroupsSrc={isAtSwiper}
            syncGroupsWrapId={atSwiperDomId}
            class={style['img-div']}
            src={this.rootPath + 'btn_sc_off.png'}
          />
        )}
      </div>
    )
  }
}
